import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_CUSTOMER_CREDIT_BALANCE,
  SOFTLINE_API_DOCUMENT_CREDIT_LIMIT,
} from '../customer-info.api';
import { CustomerCreditBalance, DocumentCreditLimit } from '../types/credit';

/** Both credit endpoints are read-only and free of side effects — refetching is
    safe. Use the document-bound one whenever a document is loaded: it splits the
    current document out of the customer balance and returns the backend's
    assessment (`level`). */
@Injectable({ providedIn: 'root' })
export class CreditRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  getCustomerCreditBalance(customerId: string): Promise<CustomerCreditBalance> {
    return this.dataAccess.get<CustomerCreditBalance>({
      path: SOFTLINE_API_CUSTOMER_CREDIT_BALANCE,
      pathParams: { id: customerId },
    });
  }

  getDocumentCreditLimit(documentId: string): Promise<DocumentCreditLimit> {
    return this.dataAccess.get<DocumentCreditLimit>({
      path: SOFTLINE_API_DOCUMENT_CREDIT_LIMIT,
      pathParams: { id: documentId },
    });
  }
}
